import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    icon: {
        width: '48px',
        height: '48px',
        padding: 0,
    },
    menuList: {
        fontSize: '18px',
    },
}));
